enum SceneObjectStyleEnum {
    Disabled = 'Disabled',
    Normal = 'Normal',
    Hovered = 'Hovered',
    Selected = 'Selected',
    Drawable = 'Drawable',
    Editing = 'Editing'
}

class SceneObjectStyle {
    color: number;
    lineWidth: number;

    constructor(color: number, lineWidth: number) {
        this.color = color;
        this.lineWidth = lineWidth;
    }
};

const SceneObjectStyles: { [key in SceneObjectStyleEnum]: SceneObjectStyle } = {
    [SceneObjectStyleEnum.Disabled]: new SceneObjectStyle(0xA0A0A0, 1), // Light gray for disabled, low contrast to indicate inactivity
    [SceneObjectStyleEnum.Normal]: new SceneObjectStyle(0x4C4C4C, 1), // Gray for normal state, neutral and clear for default objects
    [SceneObjectStyleEnum.Hovered]: new SceneObjectStyle(0x8B0000, 3), // Bright cyan for hover, vibrant to draw attention without clashing
    [SceneObjectStyleEnum.Selected]: new SceneObjectStyle(0xFF6F00, 2), // Orange for selected, distinct from hover and visually prominent
    [SceneObjectStyleEnum.Drawable]: new SceneObjectStyle(0x006600, 1.5), // Green for drawable, indicating active creation/editing
    [SceneObjectStyleEnum.Editing]: new SceneObjectStyle(0x1565C0, 2.5) // Blue for active editing/move
};

const getSceneObjectStyle = (style: SceneObjectStyleEnum): SceneObjectStyle => {
    return SceneObjectStyles[style];
};

const getSceneObjectStyleName = (style: SceneObjectStyle): string => {
    const entry = (Object.entries(SceneObjectStyles) as [SceneObjectStyleEnum, SceneObjectStyle][])
        .find(([, s]) => s === style);
    return entry ? entry[0] : `Custom-#${style.color.toString(16).toUpperCase()}`;
};

export { SceneObjectStyleEnum, getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle };